import Keycloak from 'keycloak-js';

// Keycloak configuration
const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://keycloak-dev.ns.io.vn',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'online-learning',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'frontend'
};

// Initialize Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;